module.exports = __webpack_public_path__ + "static/media/sybilltrelawney.c904dc21.jpeg";